import type { FilterOptionsState } from '@mui/material'
import type { PlayerSummary } from 'types/fpl/elements'

export const filterPlayers = (
  options: PlayerSummary[],
  state: FilterOptionsState<PlayerSummary>,
): PlayerSummary[] => {
  const query = state.inputValue.toLowerCase().trim()
  if (!query) return options
  return options.filter(
    option =>
      option.name.toLowerCase().includes(query) ||
      option.team_name.toLowerCase().includes(query) ||
      String(option.id).includes(query),
  )
}
